module.exports = __webpack_public_path__ + "static/assets/e28586864d5b4f6d48afbf833f8e0ec2.png";